import { render, staticRenderFns } from "./AddBomDetailModal.vue?vue&type=template&id=b696db0e&scoped=true"
import script from "./AddBomDetailModal.vue?vue&type=script&lang=js"
export * from "./AddBomDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b696db0e",
  null
  
)

export default component.exports